import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const MainContainer = styled.div`
  ${tw`mt-6`}
`;

export const OverviewContainer = styled.div`
  ${tw`pb-3 border-b border-b-gray94`}
`;

export const OverviewHeader = styled.div`
  ${tw`flex gap-3 justify-between items-center mb-2`}
`;

export const OverviewTitle = styled.div`
  ${tw`grow`}
`;

export const Title = styled.h4`
  ${tw`font-bold text-17-26 text-dark-gray mb-1`}
`;

export const Subtitle = styled.p`
  ${tw`font-medium text-xs text-dim-gray leading-5`}
`;

export const QuestionsAmount = styled.div`
  ${tw`min-w-28px text-center font-medium text-15-20 text-dark-gray px-1 bg-alice-blue rounded-100px`}
`;

export const ActivityRow = styled.div`
  ${tw`flex items-center justify-between gap-2.5`}
`;

export const QuestionsContainer = styled.div`
  ${tw`max-h-500px overflow-scroll transition-all`}
`;

export const QuestionContainer = styled.div`
  ${tw`py-3 flex flex-col gap-1 border-t border-t-gray94 first:border-t-0`}
`;

export const QuestionTitleRow = styled.div`
  ${tw`flex justify-between gap-1 py-2`}
`;

export const QuestionTitle = styled.p`
  ${tw`font-bold text-13-21 text-dark-gray`}
`;

export const QuestionDetails = styled.div`
  ${tw`text-xs leading-5 font-medium text-dim-gray`}
`;

export const QuestionInfo = styled.div`
  ${tw`flex items-center justify-between gap-6`}
`;

export const QuestionInfoWrapper = styled.div<{ $gap: number }>`
  ${tw`flex items-center justify-between text-13`}

  ${({
    $gap
  }) => `gap: ${$gap}px`}
`;

export const DeactivatedTile = styled.div`
  ${tw`rounded-100px bg-gray-whisper py-1 px-2 text-dim-gray font-medium leading-4 text-xs`}
`;
